// Mirrors GPMetals.Core.Models.Publishing. Enums come over the wire as numbers.

// Same numbering as Wilma Sync's Marketplace enum, so a result written back from Sync
// lands on the right row without translation.
export enum Marketplace {
  Ebay = 0,
  PartPro = 1,
  Shopify = 2,
}

export enum MarketplaceListingStatus {
  NotListed = 0,
  Publishing = 1,
  Live = 2,
  Failed = 3,
  Withdrawn = 4,
  Sold = 5,
}

// Ordered so a numeric sort puts what needs attention first.
export enum PublishOutcome {
  Failed = 0,
  Partial = 1,
  Pending = 2,
  Published = 3,
  NoMarketplaces = 4,
}

// Mirrors GPMetals.Core.Models.Publishing.MarketplaceListingSummary - carried on part DTOs.
export interface IMarketplaceListingSummary {
  marketplace: Marketplace;
  status: MarketplaceListingStatus;
  externalId?: string | null;
  listingUrl?: string | null;
  lastError?: string | null;
  publishedOn?: string | null;
  lastAttemptedOn?: string | null;
  executedBySync: boolean;
}

export interface IMarketplacePublishOutcome {
  marketplace: Marketplace;
  status: MarketplaceListingStatus;
  externalId?: string | null;
  error?: string | null;
  publishedOn?: string | null;
  lastAttemptedOn?: string | null;
  executedBySync: boolean;
}

export interface IPartPublishResult {
  partDataId: string;
  partOfferId?: string | null;
  tagNumber?: string | null;
  title?: string | null;
  correlationId?: string | null;
  operationId?: string | null;
  alreadyApplied: boolean;
  // Set when the part never reached any marketplace (validation, missing offer, queue rejection).
  error?: string | null;
  marketplaces: IMarketplacePublishOutcome[];
  outcome: PublishOutcome;
  summary: string;
}

export interface IPublishResultsResponse {
  correlationId: string;
  // True once every part has a settled outcome for every marketplace it was sent to.
  isComplete: boolean;
  total: number;
  failed: number;
  partial: number;
  pending: number;
  published: number;
  // Already sorted failures first, then partial, pending, published.
  parts: IPartPublishResult[];
}

export const marketplaceLabel: Record<Marketplace, string> = {
  [Marketplace.Ebay]: "eBay",
  [Marketplace.PartPro]: "PartPro",
  [Marketplace.Shopify]: "Shopify",
};

export const listingStatusLabel: Record<MarketplaceListingStatus, string> = {
  [MarketplaceListingStatus.NotListed]: "Not listed",
  [MarketplaceListingStatus.Publishing]: "Publishing",
  [MarketplaceListingStatus.Live]: "Live",
  [MarketplaceListingStatus.Failed]: "Failed",
  [MarketplaceListingStatus.Withdrawn]: "Withdrawn",
  [MarketplaceListingStatus.Sold]: "Sold",
};

export const publishOutcomeLabel: Record<PublishOutcome, string> = {
  [PublishOutcome.Failed]: "Failed",
  [PublishOutcome.Partial]: "Partial",
  [PublishOutcome.Pending]: "Pending",
  [PublishOutcome.Published]: "Published",
  [PublishOutcome.NoMarketplaces]: "No marketplaces",
};

export const isSettledStatus = (status: MarketplaceListingStatus) =>
  status !== MarketplaceListingStatus.Publishing;
